module.exports = __webpack_public_path__ + "resources/icon_28_review.f061af6ced9d35de.png";


//////////////////
// WEBPACK FOOTER
// ../src/ui/icon/img/icon_28_review.png
// module id = 474
// module chunks = 0 1 2 3 4